import {styled} from "@reside/ui";

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 15px;

  &.half {
    flex: 1 1 100%;

    .chart-wrapper {
      max-width: 60%;
    }

    @media (min-width: ${({theme}) => theme.breakpoint.lg}px) {
      flex: 0 0 50%;

      &:first-of-type {
        padding-right: 8px;
      }

      &:last-of-type {
        padding-left: 8px;
      }
    }
  }
`;

export const ReportWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
  border: 1px solid ${({theme}) => theme.color.gray10};
  border-radius: 0 0 4px 4px;
  background-color: ${({theme}) => theme.color.white};
`;

export const ReportHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 10px 16px;
  align-items: center;
  box-sizing: border-box;
  border-radius: 4px 4px 0 0;
  background-color: ${({theme}) => theme.color.lightBlue10};
  min-height: 44px;

  button {
    font-weight: bold;
  }

  a {
    text-decoration: none;
    text-transform: uppercase;
    margin-left: 20px;
    font-weight: bold;
    color: ${({theme}) => theme.color.darkBlue100};
    font-size: 11px;

    &:hover {
      opacity: 0.8;
    }

    &.active {
      color: ${({theme}) => theme.color.primary};
    }
  }
`;

export const ReportBody = styled.div`
  padding: 30px 30px 50px 30px;
  box-sizing: border-box;
  flex: 1;

  .no-data {
    text-align: center;
    padding: 120px 10px;
  }

  .spinner {
    margin-top: 32px;
  }
`;

export const ReportFooter = styled.div`
  margin: 0 0 20px 30px;

  a {
    text-decoration: none;
  }
`;
